import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AboutModalBox/about-modal-box';
import { Title } from '../Title';
export var AboutModalBoxHeader = function AboutModalBoxHeader(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$productName = _a.productName,
      productName = _a$productName === void 0 ? '' : _a$productName,
      id = _a.id,
      props = __rest(_a, ["className", "productName", "id"]);

  return React.createElement("div", Object.assign({
    className: css(styles.aboutModalBoxHeader, className)
  }, props), React.createElement(Title, {
    headingLevel: "h1",
    size: "4xl",
    id: id
  }, productName));
};